import { Trash, X, ChevronDown } from 'lucide-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeActiveFilter,
  removeAllActiveFilter,
  toggleFilterDropdown,
  triggerApply,
  updateCurrentJobRole,
  updateCurrentOwnerRole,
  updateCurrentScoreRange,
  updateCurrentSource,
  updateCurrentZipUpload,
  updateDateRange,
  updateScheduleFilter,
} from '../../store/slices/filterOptionsSlice';
import { formatDateTimeForZipMenue } from '../../utils/date';
import DateRangePicker from '../DatePicker';
import { useTheme } from '../../hooks/useTheme';
import {
  getAllCandidatesForInterviewThunk,
  getAllOwnersForInterviewThunk,
  getJobPositionsThunk,
} from '../../store/thunks/InterviewThunk';
import { toast } from 'react-toastify';
import DropDownWithSearch from '../shared/DropDownWIthSearch';
import { buildInterviewThunkParams } from '../../Services/interviewManagement.service';
import Slider from 'rc-slider';
// import {calendarOverrideStyles} from '../../orgadmin/candidateAnalytics';
import PlatformCalendar from './platformCalendar';
import { calendarOverrideStyles } from './datePickerStyles';
// const TAB_SUBTAB_MAP = {
//   SOURCED: ["MY_UPLOADS", "SOURCED_CANDIDATES"],
//   INTERVIEW: ["SCHEDULED", "PROGRESS", "COMPLETED"],
//   DECISION: ["ACCEPTED", "REJECTED"],
// };

const SCHDULE_STATUS_MAP = ['All', 'Pending', 'In Progress', 'Completed' , 'Rescheduled', 'Cancelled - HR', 'Cancelled - Candidate', 'Cancelled - System'];
function FilterDropDown() {
  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  const showFilterDropdown = useSelector(
    (state) => state.filterSlice.showFilterDropdown,
  );
  const currentZipUpload = useSelector(
    (state) => state.filterSlice.currentZipUpload,
  );
  const jobroles = useSelector(
    (state) => state.interviewManagementSlice.jobroles,
  );
  const notification = useSelector(
    (state) => state.candidateManagementSlice.notifications,
  );
  const filterRef = useRef();
  const DateRange = useSelector((state) => state.filterSlice.dateRange);
  const { theme } = useTheme();
  const filterState = useSelector((state) => state.filterSlice);
  const filterCount = useSelector((state) => state.filterSlice.filterCount);
  const activeFilters = useSelector((state) => state.filterSlice.activeFilters);
  const allSources = useSelector((state) => state.filterSlice.allSources);
  const currentSource = useSelector((state) => state.filterSlice.currentSource);
  const currentJobRole = useSelector(
    (state) => state.filterSlice.currentJobRole,
  );
  const AllOwnersdata = useSelector((state) => state.filterSlice.allOwners);
  const allOwners = AllOwnersdata.map((user) => user.name);
  const sourceDropdownRef = useRef();
  const currentOwner = useSelector((state) => state.filterSlice.currentOwner);
  const scheduledStatusFilter = useSelector(
    (state) => state.filterSlice.scheduledStatusFilter,
  );
  const jobRoleDropdownRef = useRef();
  const ownerDropdownRef = useRef();
  const calendarRef = useRef();
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const dispatch = useDispatch();

  const MIN = 0;
  const MAX = 100;

  const { min: minScore, max: maxScore } = useSelector(
    (state) => state.filterSlice.currentScoreRange,
  );

  const [localFilters, setLocalFilters] = useState({
    zipUpload: currentZipUpload,
    source: currentSource,
    owner: currentOwner,
    jobRole: currentJobRole,
    dateRange: DateRange,
    scoreRange: { min: minScore, max: maxScore },
    scheduleStatus: scheduledStatusFilter,
  });


  const formatDateRange = (dateRange) => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) return "Select Date Range";
    return `${new Date(dateRange[0]).toLocaleDateString()} to ${new Date(dateRange[1]).toLocaleDateString()}`;
  };

  // const handleMinChange = (e) => {
  //   const value = Math.min(Number(e.target.value), maxScore - 1);
  //   dispatch(updateCurrentScoreRange({ min: value, max: maxScore }));
  // };

  const handleMinChange = (e) => {
    const value = Math.min(
      Number(e.target.value),
      localFilters.scoreRange.max - 1,
    );

    setLocalFilters((prev) => ({
      ...prev,
      scoreRange: {
        ...prev.scoreRange,
        min: value,
      },
    }));
  };

  // const handleMaxChange = (e) => {
  //   const value = Math.max(Number(e.target.value), minScore + 1);
  //   dispatch(updateCurrentScoreRange({ min: minScore, max: value }));
  // };
  const handleMaxChange = (e) => {
    const value = Math.max(
      Number(e.target.value),
      localFilters.scoreRange.min + 1,
    );

    setLocalFilters((prev) => ({
      ...prev,
      scoreRange: {
        ...prev.scoreRange,
        max: value,
      },
    }));
  };

  const handleApply = () => {
    dispatch(triggerApply());
    dispatch(toggleFilterDropdown());
  };

  const handleReset = () => {
    dispatch(removeAllActiveFilter()); // resets all filters + applyNow
    setLocalFilters({
      zipUpload: 'All',
      source: '',
      owner: '',
      jobRole: '',
      dateRange: [],
      scoreRange: { min: 0, max: 100 },
      scheduleStatus: '',
    });
    dispatch(toggleFilterDropdown());
  };

  // const minPercent = ((minScore - MIN) / (MAX - MIN)) * 100;
  // const maxPercent = ((maxScore - MIN) / (MAX - MIN)) * 100;

  const minPercent = ((localFilters.scoreRange.min - MIN) / (MAX - MIN)) * 100;

  const maxPercent = ((localFilters.scoreRange.max - MIN) / (MAX - MIN)) * 100;

  const handleRemoveFilter = (key) => {
    dispatch(removeActiveFilter(key)); // updates Redux
    dispatch(triggerApply()); // re-fetch with updated state

    // Also clear from localFilters
    setLocalFilters((prev) => {
      const updated = { ...prev };
      if (key === 'DATE_RANGE') updated.dateRange = [];
      if (key === 'JOB_ROLE') updated.jobRole = '';
      if (key === 'SCORE_RANGE') updated.scoreRange = { min: 0, max: 100 };
      if (key === 'SOURCE') updated.source = '';
      if (key === 'OWNER') updated.owner = 'All';
      // For NOTIFICATION (zip upload) key is the upload_id
      updated.zipUpload = 'All'; // safe to reset if it's a zip filter
      return updated;
    });
  };

  // const handleJobRoleSelect = (data) => {
  //   if (!data || !data.trim()) {
  //     return;
  //   }
  //   dispatch(updateCurrentJobRole(data));
  //   console.log('Handle Job Role Select Clicked');
  // };

  useEffect(() => {
    const fetchdata = async () => {
      if (jobroles.length === 0) {
        dispatch(getJobPositionsThunk());
      }
      if (allOwners.length === 0) {
        dispatch(getAllOwnersForInterviewThunk());
      }
    };
    fetchdata();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !ownerDropdownRef.current?.contains(event.target) && // ✅ exclude owner dropdown
        !jobRoleDropdownRef.current?.contains(event.target) && // ✅ exclude job role dropdown
        !calendarRef.current?.contains(event.target) // ✅ exclude calendar
      ) {
        dispatch(toggleFilterDropdown());
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dispatch]);

  const handleRemoveAllFilters = () => {
    dispatch(removeAllActiveFilter());
    dispatch(triggerApply());
    setLocalFilters({
      zipUpload: 'All',
      source: '',
      owner: '',
      jobRole: '',
      dateRange: [],
      scoreRange: { min: 0, max: 100 },
      scheduleStatus: 'All',
    });
  };

  const handleApplyFiters = () => {
    dispatch(updateCurrentZipUpload(localFilters.zipUpload)); // already handles "All"
    // Only dispatch if a real value is selected
    if (localFilters.source) {
      dispatch(updateCurrentSource(localFilters.source));
    }

    if (localFilters.owner ) {
      dispatch(updateCurrentOwnerRole(localFilters.owner));
    }

    if (localFilters.jobRole && localFilters.jobRole.trim()) {
      dispatch(updateCurrentJobRole(localFilters.jobRole));
    }

    if (localFilters.dateRange?.length) {
      dispatch(updateDateRange(localFilters.dateRange));
    }

    const { min, max } = localFilters.scoreRange;
    if (min || max ) {
      dispatch(updateCurrentScoreRange(localFilters.scoreRange));
    }

    if (localFilters.scheduleStatus) {
      console.log('this is Called here Confirmed');
      dispatch(updateScheduleFilter(localFilters.scheduleStatus)); // your Redux action
    }

    dispatch(triggerApply());
    dispatch(toggleFilterDropdown());
  };

  const handleResetFilters = () => {
    setLocalFilters({
      zipUpload: '',
      source: '',
      owner: '',
      jobRole: '',
      dateRange: null,
      scoreRange: { min: 0, max: 100 },
    });
  };

  const handleZipUploadChange = (value) => {
    setLocalFilters((prev) => ({
      ...prev,
      zipUpload: value,
    }));
  };

  const handleSourceChange = (value) => {
    setLocalFilters((prev) => ({
      ...prev,
      source: value,
    }));
  };

  const handleCurrentOwnerSelect = (data) => {
    if (!data || !data.trim()) return;

    setLocalFilters((prev) => ({
      ...prev,
      owner: data,
    }));
  };

  const handleInterviewStatusChangeForScheduledTab = (value) => {
    setLocalFilters((prev) => ({
      ...prev,
      scheduleStatus: value,
    }));
  };

  const handleJobRoleSelect = (data) => {
    if (!data || !data.trim()) return;

    setLocalFilters((prev) => ({
      ...prev,
      jobRole: data,
    }));
  };

  useEffect(() => {
    setLocalFilters({
      zipUpload: currentZipUpload,
      source: currentSource,
      owner: currentOwner,
      jobRole: currentJobRole,
      dateRange: DateRange,
      scoreRange: { min: minScore, max: maxScore },
    });
  }, [showFilterDropdown]); // re-sync every time dropdown opens

  console.log({ allOwners });
  return (
    <div className=" relative transition-all duration-200" ref={filterRef}>
      <style>{calendarOverrideStyles(theme)}</style>
      {showFilterDropdown && (
        <div className={`absolute z-[99999] ${activeTab === "SOURCED" ? 'right-28' : 'right-16'} -top-2 mt-2 w-[25rem]  border border-gray-600 rounded-lg shadow-sm dark:shadow-lg   p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary [backdrop-filter:blur(500px)]`}>
          <div
            className="absolute -top-[9px] right-16 w-4 h-4 rotate-45 
            border-l border-t border-gray-600 
            dark:bg-[#0b0b1f] bg-bgPrimary"
          ></div>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium dark:text-[#D9D9D9] text-textSecondary">
              Filter
            </h3>
            <button
              onClick={() => dispatch(toggleFilterDropdown())}
              className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          {filterCount > 0 && (
            <div className="mb-4">
              <div className="flex items-center justify-between mb-2">
                <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                  Active Filters
                </label>
                <button
                  onClick={handleRemoveAllFilters}
                  className="text-xs text-blue-400 hover:text-blue-300"
                >
                  Clear All
                </button>
              </div>
              <div className="flex flex-wrap gap-2">
                {activeFilters.map((filter, index) => {
                  console.log('Current filter:', filter); // 👈 add this

                  return (
                    <div
                      key={filter.key}
                      className="flex items-center dark:bg-gray-700/50 bg-violet-600 text-xs px-3 py-1 rounded-full text-white"
                    >
                      <span>{filter.label}</span>
                      <button
                        onClick={() => handleRemoveFilter(filter.key)}
                        className="ml-2 text-gray-200 hover:text-white"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className="space-y-4">
            {(activeSubTab === 'MY_UPLOADS' ||
              (activeSubTab === 'ALL' && activeTab === 'SOURCED')) && (
              <div>
                <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                  ZIP Files
                </label>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="zip"
                      value="All"
                      checked={localFilters.zipUpload === 'All'}
                      onChange={() =>
                        setLocalFilters((prev) => ({
                          ...prev,
                          zipUpload: 'All',
                        }))
                      }
                      className="text-blue-500 focus:ring-blue-500 accent-blue-600"
                    />
                    <span className="text-sm dark:text-gray-300 text-textSecondary">
                      All ZIP Files
                    </span>
                  </label>
                  {notification.map((notif) => (
                    <label
                      key={notif.upload_id}
                      className="flex items-center space-x-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="zip"
                        value={notif.upload_id}
                        checked={
                          localFilters.zipUpload?.upload_id === notif.upload_id
                        }
                        onChange={() => {
                          // dispatch(updateCurrentZipUpload(notif))
                          handleZipUploadChange(notif);
                        }}
                        className="text-blue-500 focus:ring-blue-500 accent-blue-600"
                      />
                      <span className="text-sm dark:text-gray-300 text-textSecondary">
                        {formatDateTimeForZipMenue(notif.bulk_upload_date)}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            {(activeSubTab === 'SOURCED_CANDIDATES' ||
              (activeSubTab === 'ALL' && activeTab === 'SOURCED')) && (
              <div>
                <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                  Source of application
                </label>
                <div className="relative h-10" ref={sourceDropdownRef}>
                  <DropDownWithSearch
                    options={allSources.map((source) => ({
                      label: source,
                      value: source,
                    }))}
                    selectedValue={{
                      label: localFilters.source,
                      value: localFilters.source,
                    }}
                    onSelect={(item) => handleSourceChange(item.value)}
                    placeholder="Select a Source"
                    dropdownData={allSources.map((source) => ({
                      label: source,
                      value: source,
                    }))}
                    handleCrossClick={() => handleSourceChange('')}
                    key={localFilters.source}
                    specialClasses="h-8 z-[99] border border-gray-500 dark:border-gray-400"
                  />
                </div>
              </div>
            )}
            {(activeTab === 'INTERVIEW' || activeTab === 'DECISION') &&
              false && (
                <div>
                  <div className={`flex items-center justify-between mb-2 `}>
                    <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                      Job Role
                    </label>
                  </div>
                  <div className="relative h-8" ref={jobRoleDropdownRef}>
                    <DropDownWithSearch
                      className="text-white backdrop-filter h-6 backdrop-blur-[500px] placeholder:text-gray-200 placeholder:text-sm z-[999999]"
                      options={jobroles.map((role) => ({
                        label: role,
                        value: role,
                      }))}
                      selectedOption={localFilters.jobRole}
                      onSelect={(item) => handleJobRoleSelect(item.label)}
                      placeholder="Search Job Role"
                      dropdownData={jobroles.map((role) => ({
                        label: role,
                        value: role,
                      }))}
                      handleCrossClick={() => {
                        handleJobRoleSelect('');
                      }}
                      specialClasses="h-8 z-[99999]"
                      key={localFilters.jobRole}
                    />
                  </div>
                </div>
              )}
            {(activeTab === 'INTERVIEW' || activeTab === 'DECISION') && (
              <div>
                <div className={`flex mt-2 items-center justify-between mb-2 `}>
                  <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                    Owner
                  </label>
                </div>
                <div className="relative h-8" ref={ownerDropdownRef}>
                  <DropDownWithSearch
                    className="text-white backdrop-filter h-6 backdrop-blur-[500px] placeholder:text-gray-200 placeholder:text-sm z-[9999]"
                    options={allOwners.map((role) => ({
                      label: role,
                      value: role,
                    }))}
                    selectedValue={{
                      label: localFilters.owner,
                      value: localFilters.owner,
                    }}
                    onSelect={(item) => handleCurrentOwnerSelect(item.label)}
                    placeholder="Select a Owner"
                    dropdownData={allOwners.map((role) => ({
                      label: role,
                      value: role,
                    }))}
                    handleCrossClick={() => {
                      handleCurrentOwnerSelect('');
                    }}
                    key={localFilters.owner}
                    specialClasses="h-8 z-[9999] border border-gray-500 dark:border-gray-400"
                  />
                </div>
              </div>
            )}
            {activeTab === 'INTERVIEW' && (activeSubTab === 'SCHEDULED' || activeSubTab === "ALL") && (
              <div>
                <div className={`flex mt-2 items-center justify-between mb-2 `}>
                  <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                    Status
                  </label>
                </div>
                <div className="relative h-8" ref={ownerDropdownRef}>
                  <DropDownWithSearch
                    className="text-white backdrop-filter h-6 backdrop-blur-[500px] placeholder:text-gray-200 placeholder:text-sm z-[999]"
                    options={SCHDULE_STATUS_MAP.map((role) => ({
                      label: role,
                      value: role,
                    }))}
                    selectedValue={{
                      label: localFilters.scheduleStatus,
                      value: localFilters.scheduleStatus,
                    }}
                    onSelect={(item) =>
                      handleInterviewStatusChangeForScheduledTab(item.label)
                    }
                    placeholder="Select a Status"
                    dropdownData={SCHDULE_STATUS_MAP.map((role) => ({
                      label: role,
                      value: role,
                    }))}
                    handleCrossClick={() => {
                      handleInterviewStatusChangeForScheduledTab('');
                    }}
                    key={localFilters.owner}
                    specialClasses="h-8 z-[99] border border-gray-500 dark:border-gray-400"
                  />
                </div>
              </div>
            )}
            <div>
              <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                Date Range
              </label>
              <div className="relative" ref={calendarRef}>
                <button
                  className="flex items-center justify-between w-full dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-200 text-sm font-light h-10"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsCalendarOpen(!isCalendarOpen);
                  }}
                  aria-expanded={isCalendarOpen}
                >
                  <span className="truncate">
                    {formatDateRange(localFilters.dateRange)}
                  </span>
                  {localFilters.dateRange?.length === 2 && localFilters.dateRange[0] ? (
                    <X
                      className="w-4 h-4"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLocalFilters(prev => ({ ...prev, dateRange: [null, null] }));
                        setIsCalendarOpen(false);
                      }}
                    />
                  ) : (
                    <ChevronDown className="w-4 h-4" />
                  )}
                </button>
                {isCalendarOpen && (
                  <div
                    className="candidate-analytics-calendar absolute mt-2 z-[100] right-0"
                    style={{
                      background: theme === 'dark' ? "#0a1733" : "#fff",
                      border: "1px solid #4b5563",
                      borderRadius: "8px"
                    }}
                  >
                    <div className={`platform-calendar ${theme}`}>
                      <PlatformCalendar
                        onChange={(value) => {
                          setLocalFilters((prev) => ({
                            ...prev,
                            dateRange: value,
                          }));
                          if (value[0] && value[1]) {
                            setIsCalendarOpen(false);
                          }
                        }}
                        value={localFilters.dateRange}
                        selectRange={true}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {activeSubTab != 'SCHEDULED' && (
              <div className="mt-10 mb-10">
                <div className={`flex mt-2 items-center justify-between mb-2`}>
                  <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                    Score Range
                  </label>
                </div>
                <div className="relative h-6 flex items-center">
                  {/* Base track */}
                  <Slider
                    range
                    min={MIN}
                    max={MAX}
                    value={[
                      localFilters.scoreRange.min,
                      localFilters.scoreRange.max,
                    ]}
                    onChange={([min, max]) => {
                      handleMinChange({ target: { value: min } });
                      handleMaxChange({ target: { value: max } });
                    }}
                    trackStyle={[{ background: "linear-gradient(to right, #6366f1, #ec4899)", height: 4 }]}
                    handleStyle={[
                      {
                        borderColor: '#6366f1',
                        backgroundColor: '#FFFFFF',
                        opacity: 1,
                        boxShadow: '0 0 0 2px white',
                        width: 14,
                        height: 14,
                        marginTop: -5,
                      },
                      {
                        borderColor: '#ec4899',
                        backgroundColor: '#FFFFFF',
                        opacity: 1,
                        boxShadow: '0 0 0 2px white',
                        width: 14,
                        height: 14,
                        marginTop: -5,
                      },
                    ]}
                    railStyle={{ backgroundColor: '#e5e7eb' }}
                  />
                </div>

                {/* Display values */}
                <div className="flex justify-between mt-2 text-xs text-gray-500">
                  <span className="text-sm">
                    {localFilters.scoreRange.min}%
                  </span>
                  <span className="text-sm">
                    {localFilters.scoreRange.max}%
                  </span>
                </div>
              </div>
            )}

            <div className="mt-10 mb-10 flex flex-row items-center space-x-4">             
              <button
                onClick={handleReset}
                className={`w-full py-2 px-4 ${theme === 'dark' ? 'button' : 'border-btn'}`}
              >
                <span className="dark:text-white text-textPrimary">Reset</span>
              </button>
              <button
                onClick={handleApplyFiters}
                className="w-full py-2 px-4 bg-gradient-to-r from-indigo-500 to-pink-500 text-white rounded-full hover:from-indigo-600 hover:to-pink-600 transition-colors"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterDropDown;
